import React from 'react';
import { ArrowRight, Coins, Wallet, ArrowDownUp, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import soldex from '../../assets/images/soldex.jpg'

const SolanaBuyPage = () => {
  return (
    <div className="bg-gradient-to-r from-sky-50 via-sky-50/80 to-white min-h-screen">
      <div className="max-w-8xl mx-auto px-4 pt-6 pb-8 md:py-16">
        {/* Back Button */}
        <Link
          to="/buy"
          className="inline-flex items-center gap-2 text-sky-500 hover:text-sky-600 transition-colors mb-8 md:mb-12"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">Back to options</span>
        </Link>

        <div className="flex flex-col lg:flex-row">
          {/* Left side - Content */}
          <div className="w-full lg:w-3/5 pr-0 lg:pr-8">
            <div className="text-center mb-8 md:mb-12">
              <h1 className="text-3xl md:text-4xl font-bold text-sky-500 mb-4">How to Buy $BOOP on Solana</h1>
            </div>

            <div className="space-y-4 md:space-y-6">
              {/* Step 1 */}
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-sky-200 hover:bg-white hover:border-sky-300 transition-all shadow-sm">
                <div className="flex flex-col md:flex-row items-start gap-4">
                  <div className="bg-sky-50 rounded-lg p-3">
                    <ArrowDownUp className="w-6 h-6 text-sky-500" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-sky-500 mb-2">1. Load up your favourite SOL DEX</h3>
                    <p className="text-gray-600 mb-4">Choose your preferred DEX to trade:</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <a
                        href="https://jupiter.xyz"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white/50 hover:bg-white text-sky-500 rounded-lg p-4 text-left transition-colors flex items-center justify-between group border border-sky-200 hover:border-sky-300"
                      >
                        <div>
                          <span className="font-medium">Jupiter</span>
                          <p className="text-sm text-gray-500 mt-1">Recommended option</p>
                        </div>
                        <ArrowRight className="w-5 h-5 text-sky-400 group-hover:text-sky-500 transform group-hover:translate-x-1 transition-all" />
                      </a>
                      <a
                        href="https://raydium.io"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white/50 hover:bg-white text-sky-500 rounded-lg p-4 text-left transition-colors flex items-center justify-between group border border-sky-200 hover:border-sky-300"
                      >
                        <div>
                          <span className="font-medium">Raydium</span>
                          <p className="text-sm text-gray-500 mt-1">Alternative option</p>
                        </div>
                        <ArrowRight className="w-5 h-5 text-sky-400 group-hover:text-sky-500 transform group-hover:translate-x-1 transition-all" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-sky-200 hover:bg-white hover:border-sky-300 transition-all shadow-sm">
                <div className="flex flex-col md:flex-row items-start gap-4">
                  <div className="bg-sky-50 rounded-lg p-3">
                    <Wallet className="w-6 h-6 text-sky-500" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-sky-500 mb-2">2. Connect your wallet</h3>
                    <p className="text-gray-600 mb-4">Any Solana compatible wallet will work. Recommended options:</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                      <button className="bg-white/50 hover:bg-white text-sky-500 rounded-lg p-4 text-left transition-colors border border-sky-200 hover:border-sky-300">
                        <span className="font-medium">Phantom</span>
                        <p className="text-sm text-gray-500 mt-1">Most popular Solana wallet</p>
                      </button>
                      <button className="bg-white/50 hover:bg-white text-sky-500 rounded-lg p-4 text-left transition-colors border border-sky-200 hover:border-sky-300">
                        <span className="font-medium">Solflare</span>
                        <p className="text-sm text-gray-500 mt-1">Feature-rich Solana wallet</p>
                      </button>
                    </div>
                    <p className="text-gray-700">Make sure you have some $SOL in your wallet to execute the trade.</p>
                    <p className="text-sm text-gray-500 mt-2">You can withdraw from a CEX or buy directly through your wallet's interface if supported.</p>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-sky-200 hover:bg-white hover:border-sky-300 transition-all shadow-sm">
                <div className="flex flex-col md:flex-row items-start gap-4">
                  <div className="bg-sky-50 rounded-lg p-3">
                    <Coins className="w-6 h-6 text-sky-500" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-sky-500 mb-2">3. Setup your trade</h3>
                    <p className="text-gray-900 font-medium mb-1">YOU'RE SELLING:</p>
                    <p className="text-gray-600 text-sm mb-4">Select your source currency (e.g. $SOL)</p>
                    <p className="text-gray-900 font-medium mb-1">YOU'RE BUYING:</p>
                    <p className="text-gray-600 text-sm">Enter the BOOP (Wormhole) contract address below</p>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-sky-200 hover:bg-white hover:border-sky-300 transition-all shadow-sm">
                <div className="flex flex-col md:flex-row items-start gap-4">
                  <div className="bg-sky-50 rounded-lg p-3">
                    <ArrowRight className="w-6 h-6 text-sky-500" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-sky-500 mb-2">4. Execute the trade</h3>
                    <p className="text-gray-600">Once the platform gives you a quote, execute the trade.</p>
                  </div>
                </div>
              </div>

              {/* Contract Info */}
              <div className="bg-sky-50/80 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-sky-200">
                <h3 className="text-lg font-semibold text-sky-500 mb-2">BOOP Contract Address</h3>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
                  <code className="flex-1 bg-white/80 text-sky-600 p-3 rounded-lg break-all border border-sky-200 text-sm md:text-base">
                    2HrZ5R18H48b8ptL3n8N5zX65zDB4o2cMCHcP3QfSfye
                  </code>
                  <button
                    onClick={() => navigator.clipboard.writeText('2HrZ5R18H48b8ptL3n8N5zX65zDB4o2cMCHcP3QfSfye')}
                    className="bg-sky-500 hover:bg-sky-600 text-white px-4 py-2 rounded-lg transition-colors whitespace-nowrap"
                  >
                    Copy
                  </button>
                </div>
                <p className="text-sm text-gray-600 mt-2">
                  Always verify the contract address before making any transactions
                </p>
              </div>
            </div>
          </div>

          {/* Right side - Image */}
          <div className="w-full lg:w-2/5 p-4 md:p-12 mt-8 lg:mt-0">
            <div className="text-center mb-4 md:mb-6">
              <h3 className="text-xl font-semibold text-sky-500 mb-2">Example Interface</h3>
              <p className="text-gray-600">Here's how Jupiter's swap interface looks</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm p-4 md:p-6 rounded-2xl shadow-md border border-sky-200">
              <img 
                src={soldex}
                alt="Jupiter Interface Example" 
                className="rounded-xl shadow-sm w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolanaBuyPage;